import $ from 'jquery';

export default function showFlash(type, message) {
  let $container = $('.flash-messages');
  if ($container.length === 0) {
    $container = $('<div class="flash-messages"></div>');
    $('body').prepend($container);
  }

  const $flash = $('<div class="alert">').addClass('alert-' + type);
  const $closeBtn = $('<button class="close" type="button">×</button>');
  const $messageDiv = $('<div id="flash_alert"></div>').text(message);

  $flash.append($closeBtn);
  $flash.append($messageDiv);

  $container.append($flash);

  $flash.slideDown(500).delay(5000).slideUp(500, function () {
    $(this).remove();
  });
}

$(function () {
  $('body').on('click', '.alert button.close', function () {
    $(this).closest('.alert').stop(true, true).slideUp(500, function () {
      $(this).remove();
    });
  });

  $('.alert-success')
    .not('.stay-open')
    .delay(5000)
    .slideUp(300, function () {
      $(this).alert('close');
    });
});
